/* ==========================================================================
   tx-base.js — TRAILIX Runtime (Overlay auf Dawn 16)
   Eine IIFE, kein Framework. Verhalten klinkt sich ueber data-tx-* ein.
   Produktdaten kommen aus Liquid, nicht von hier — dieses File ist nur UI.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal beim Scrollen ---------------------------------------- */
  var io = null;
  function observeReveal(root) {
    var els = (root || document).querySelectorAll('.tx-reveal:not(.tx-in)');
    if (reduced || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('tx-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('tx-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
    }
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }
  window.txObserve = observeReveal;

  /* ---- Header: Schatten ab 20px ------------------------------------ */
  function headerScroll() {
    var hdr = document.querySelector('[data-tx-header]');
    if (!hdr) return;
    var onScroll = function () { hdr.classList.toggle('tx-scrolled', window.scrollY > 20); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Mobile-Navigation ------------------------------------------- */
  function mobileNav() {
    var nav = document.querySelector('[data-tx-mobile]');
    if (!nav) return;
    var open = function () {
      nav.classList.add('tx-show');
      nav.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var first = nav.querySelector('a, button');
      if (first) first.focus();
    };
    var close = function () {
      nav.classList.remove('tx-show');
      nav.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-tx-burger]')) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-tx-mobile-close]') || e.target.closest('.tx-mlink')) { close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('tx-show')) close();
    });
  }

  /* ---- FAQ-Akkordeon (ein Eintrag offen) --------------------------- */
  function faq(root) {
    var qs = (root || document).querySelectorAll('.tx-fq-q');
    Array.prototype.forEach.call(qs, function (q) {
      if (q.dataset.txBound) return;
      q.dataset.txBound = '1';
      q.addEventListener('click', function () {
        var fq = q.closest('.tx-fq');
        var a = fq.querySelector('.tx-fq-a');
        var wasOpen = fq.classList.contains('tx-open');
        var group = fq.closest('[data-tx-faq]') || document;
        Array.prototype.forEach.call(group.querySelectorAll('.tx-fq'), function (o) {
          o.classList.remove('tx-open');
          var oa = o.querySelector('.tx-fq-a');
          if (oa) oa.style.maxHeight = null;
          var ob = o.querySelector('.tx-fq-q');
          if (ob) ob.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          fq.classList.add('tx-open');
          a.style.maxHeight = a.scrollHeight + 'px';
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---- Countdown: laeuft bis Tagesende, setzt sich taeglich zurueck --
     Bewusst ohne echte Kampagnen-Deadline (siehe _TEMPLATE/CLAUDE.md).     */
  function countdown() {
    var clocks = document.querySelectorAll('[data-tx-clock]');
    if (!clocks.length) return;
    var end = new Date(); end.setHours(23, 59, 59, 999);
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var d = end - new Date();
      if (d < 0) { end.setDate(end.getDate() + 1); d = end - new Date(); }
      var h = Math.floor(d / 3.6e6), m = Math.floor(d % 3.6e6 / 6e4), s = Math.floor(d % 6e4 / 1e3);
      Array.prototype.forEach.call(clocks, function (c) {
        var eh = c.querySelector('[data-h]'), em = c.querySelector('[data-m]'), es = c.querySelector('[data-s]');
        if (eh) eh.textContent = pad(h);
        if (em) em.textContent = pad(m);
        if (es) es.textContent = pad(s);
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Mengen-Stepper ---------------------------------------------- */
  function qtySteppers(root) {
    var boxes = (root || document).querySelectorAll('[data-tx-qty]');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.dataset.txBound) return;
      box.dataset.txBound = '1';
      var input = box.querySelector('input');
      if (!input) return;
      var clamp = function (v) { return Math.max(1, Math.min(99, parseInt(v, 10) || 1)); };
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tx-step]');
        if (!b) return;
        e.preventDefault();
        input.value = clamp(Number(input.value) + Number(b.dataset.txStep));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      input.addEventListener('input', function () { input.value = clamp(input.value); });
    });
  }

  /* ---- PDP-Galerie: Thumbnail -> Hauptbild ------------------------- */
  function gallery(root) {
    var gals = (root || document).querySelectorAll('[data-tx-gallery]');
    Array.prototype.forEach.call(gals, function (gal) {
      if (gal.dataset.txBound) return;
      gal.dataset.txBound = '1';
      var main = gal.querySelector('[data-tx-main-img]');
      gal.addEventListener('click', function (e) {
        var t = e.target.closest('[data-tx-thumb]');
        if (!t || !main) return;
        e.preventDefault();
        Array.prototype.forEach.call(gal.querySelectorAll('[data-tx-thumb]'), function (x) {
          x.classList.remove('tx-active');
          x.setAttribute('aria-selected', 'false');
        });
        t.classList.add('tx-active');
        t.setAttribute('aria-selected', 'true');
        main.src = t.dataset.txSrc || main.src;
        if (t.dataset.txSrcset) main.srcset = t.dataset.txSrcset;
        if (t.dataset.txAlt) main.alt = t.dataset.txAlt;
      });
    });
  }

  /* ---- Sticky Buy-Bar: sichtbar, sobald die Buybox durch ist ------- */
  function stickyBar() {
    var bar = document.querySelector('[data-tx-sticky]');
    var anchor = document.querySelector('[data-tx-sticky-anchor]');
    if (!bar || !anchor) return;
    var onScroll = function () {
      bar.classList.toggle('tx-show', anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }


  /* ---- Variantenwechsel: Preis, Ersparnis, Bild, Verfuegbarkeit ------
     Die Preview hatte nur Preis-Deltas; hier kommen alle Werte aus Liquid
     (data-Attribute je Variante), damit nichts doppelt gepflegt werden muss. */
  function variants(root) {
    var groups = (root || document).querySelectorAll('[data-tx-variants]');
    Array.prototype.forEach.call(groups, function (group) {
      if (group.dataset.txBound) return;
      group.dataset.txBound = '1';
      group.addEventListener('change', function (e) {
        var input = e.target.closest('[data-tx-variant]');
        if (!input) return;

        Array.prototype.forEach.call(group.querySelectorAll('.tx-variant'), function (l) {
          l.classList.toggle('tx-active', l.contains(input));
        });

        var price = document.querySelector('[data-tx-price]');
        var compare = document.querySelector('[data-tx-compare]');
        var save = document.querySelector('[data-tx-save]');
        var buy = document.querySelector('[data-tx-buy]');
        var main = document.querySelector('[data-tx-main-img]');

        if (price) price.textContent = input.dataset.price || price.textContent;

        var hasCompare = input.dataset.hasCompare === '1';
        if (compare) {
          compare.textContent = hasCompare ? input.dataset.compare : '';
          compare.hidden = !hasCompare;
        }
        if (save) {
          save.textContent = hasCompare ? 'Du sparst ' + input.dataset.save : '';
          save.hidden = !hasCompare;
        }
        if (buy) {
          var available = input.dataset.available === '1';
          buy.disabled = !available;
          buy.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
        }
        if (main && input.dataset.image) main.src = input.dataset.image;
      });
    });
  }

  /* ---- Init + Theme-Editor ----------------------------------------- */
  function init(root) {
    observeReveal(root);
    faq(root);
    qtySteppers(root);
    gallery(root);
    variants(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(); headerScroll(); mobileNav(); countdown(); stickyBar();
    });
  } else {
    init(); headerScroll(); mobileNav(); countdown(); stickyBar();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    headerScroll(); mobileNav(); countdown(); stickyBar();
  });
})();
